import { createSlice } from "@reduxjs/toolkit";
import { showNotification } from "./notificationSlice";
import { factory } from "../../api/apiFactory";
const invoiceApi = factory.get("invoice");

const emptyItem = {
  product_id: null,
  quantity: 1,
  price: 0,
  discount: 0,
  net_price: 0,
  total_amount: 0,
  serial_numbers: [],
};

const initialState = {
  searchBody: {},
  invoice: {
    loading: false,
    dialog: false,
    form: {
      id: "",
      supplier_id: null,
      discount: 0,
      total_amount: 0,
      items: [],
    },
  },
  invoices: {
    loading: false,
    data: [],
    total: 0,
    total_amount: 0,
  },
};

export const invoiceSlice = createSlice({
  name: "invoice",
  initialState,
  reducers: {
    setDialog: (state, action) => {
      state.invoice.dialog = !state.invoice.dialog;
    },
    setDataTable: (state, { payload }) => {
      state.invoices.data = payload.data.data;
      state.invoices.total = payload.data.total;
      state.invoices.total_amount = payload.data.total_amount;
    },
    setById: (state, { payload }) => {
      state.invoice.form = {
        id: payload.id,
        supplier_id: payload.supplier_id,
        discount: payload.discount ?? 0,
        total_amount: payload.total_amount ?? 0,
        items:
          payload.items?.map((item) => ({
            ...emptyItem,
            ...item,
            serial_numbers: item.serial_numbers ?? [],
          })) ?? [],
      };
    },
    setLoading: (state, action) => {
      state.invoices.loading = !state.invoices.loading;
    },
    resetForm: (state, action) => {
      state.invoice.form = initialState.invoice.form;
    },
    setSearchBody: (state, { payload }) => {
      state.searchBody = payload;
    },
  },
});

export const {
  setLoading,
  setDialog,
  setById,
  setDataTable,
  resetForm,
  setSearchBody,
} = invoiceSlice.actions;

export default invoiceSlice.reducer;

//axios
const getAll = (params) => async (dispatch) => {
  try {
    dispatch(setLoading());
    const res = await invoiceApi.getAll(params);
    dispatch(setDataTable(res));
    dispatch(setLoading());
  } catch (err) {
    dispatch(setLoading());
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    throw new Error(err);
  }
};
const getById = (id) => async (dispatch) => {
  try {
    dispatch(setLoading());
    const res = await invoiceApi.getById(id);
    dispatch(setById(res.data.data[0]));
    dispatch(setDialog());
    dispatch(setLoading());
  } catch (err) {
    dispatch(setLoading());
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    throw new Error(err);
  }
};
const create = (data, _SearchBody) => async (dispatch) => {
  try {
    await invoiceApi.create(data);
    dispatch(
      showNotification({
        message: "تمت الاضافة بنجاح",
        type: "success",
      })
    );
    dispatch(setDialog());
    dispatch(getAll(_SearchBody));
  } catch (err) {
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    throw new Error(err);
  }
};
const update = (id, data, _SearchBody) => async (dispatch) => {
  try {
    await invoiceApi.update(id, data);
    dispatch(
      showNotification({
        message: "تم التعديل بنجاح",
        type: "success",
      })
    );
    dispatch(setDialog());
    dispatch(getAll(_SearchBody));
  } catch (err) {
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    throw new Error(err);
  }
};

const deleteById = (id, _SearchBody) => async (dispatch) => {
  try {
    await invoiceApi.delete(id);
    dispatch(
      showNotification({
        message: "تم الحذف بنجاح",
        type: "success",
      })
    );
    dispatch(getAll(_SearchBody));
  } catch (err) {
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    throw new Error(err);
  }
};

export const Invoice = {
  getAll,
  getById,
  create,
  update,
  deleteById,
};
